import type { IWixAPI } from '@wix/yoshi-flow-editor';

export async function hasMultiplePages(wixAPI: IWixAPI): Promise<boolean> {
  const { pages } = await wixAPI.site.getSiteStructure();
  return (
    pages.filter((page) => 'applicationId' in page && page.applicationId === '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3')
      .length > 1
  );
}
